export default __webpack_public_path__ + "static/iced-coffee-73707acc0979c274b64b45596f49bc46.jpg";